enum STEPS {
  SCHEDULE_DONE = 1,
  OFFER_DONE,
  DOCUMENTS_TO_ANALYSIS,
  CONTRACT_DONE,
  CONTRACT_FINISHED,
}

export default STEPS;
